/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Underwear(props) {
    return (
        <SvgIcon {...props}>
            <path d="M6.618,2.309c-0.07-0.075-0.684-0.729-3.217,0.13C0.874,1.58,0.259,2.233,0.188,2.309 c-0.103,0.108-0.242,0.265-0.167,0.48c0,0,0.431,1.668,1.705,1.879c0.288,0.048,0.773,0.069,1.675-1.063 c0.908,1.133,1.393,1.111,1.68,1.063c1.274-0.211,1.701-1.879,1.701-1.879C6.86,2.573,6.722,2.417,6.618,2.309z" />
            <g>
                <path d="M2.656,9.723h1.559C4.492,9.19,5.33,7.852,6.805,7.644V6.527L0,6.533v1.104 C1.515,7.813,2.375,9.184,2.656,9.723z" />
                <path d="M9.622,7.753H7.837l-0.01,0.566c-0.001,0-0.54-0.01-0.736,0c-1.545,0.073-2.326,1.873-2.333,1.892 l-0.091,0.214H4.534H3.045L2.936,13h3.206l0.247-1.431L6.912,13H10L9.622,7.753z" />
            </g>
        </SvgIcon>
    );
}

Underwear.defaultProps = {
    viewBox: '0 0 10 16'
};

export default Underwear;
